// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StatCard_card__ERyEh {
  background-color: var(--surface);
  border: 1px solid var(--border);
  border-radius: 0.5rem;
}

.StatCard_label__TLcER {
  color: var(--text-secondary);
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.StatCard_iconBox__GDdlm {
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid var(--border);
  border-radius: 0.2775rem;
  color: var(--accent);
}

.StatCard_value__0reR- {
  color: var(--text);
  font-size: 2.25rem;
  font-weight: 700;
  line-height: 1.1;
  letter-spacing: -0.02em;
}

@media (max-width: 575.98px) {
  .StatCard_value__0reR- {
    font-size: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/StatCard/StatCard.module.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,+BAA+B;EAC/B,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".card {\n  background-color: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 0.5rem;\n}\n\n.label {\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.iconBox {\n  width: 2.5rem;\n  height: 2.5rem;\n  border: 1px solid var(--border);\n  border-radius: 0.2775rem;\n  color: var(--accent);\n}\n\n.value {\n  color: var(--text);\n  font-size: 2.25rem;\n  font-weight: 700;\n  line-height: 1.1;\n  letter-spacing: -0.02em;\n}\n\n@media (max-width: 575.98px) {\n  .value {\n    font-size: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `StatCard_card__ERyEh`,
	"label": `StatCard_label__TLcER`,
	"iconBox": `StatCard_iconBox__GDdlm`,
	"value": `StatCard_value__0reR-`
};
export default ___CSS_LOADER_EXPORT___;
